import React from 'react'
import { Link } from 'react-router-dom'
import * as styles from './Review.module.scss'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'

const Review = (reviews) => {
  console.log(reviews)
  const title = reviews.reviews.title
  const showTitle = reviews.reviews.showTitle
  console.log(reviews.reviews.showTitle)
  reviews = reviews.reviews.reviews

  return (
    <div>
      {showTitle && <h1 className={styles.title}>{title}</h1>}
      <div className={styles.container}>
        {reviews.map((review, index) => (
          <div key={index} className={styles.card}>
            <Link to={review.fields.link} className={styles.link}>
              <img
                className={styles.img}
                src={review.fields.watchImage.fields.file.url}
                alt={review.fields.watchImage.fields.descritpion}
              />
              <div className={styles.body}>
                <div className={styles.bodyTitle}>{review.fields.title}</div>
                <div>{review.fields.shortDescription}</div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Review
